import {
	SnippetsOutlined,
	QuestionCircleOutlined,
	GlobalOutlined,
	LoadingOutlined
} from '@ant-design/icons';
import { ReactComponent as Eye } from 'Icons/eye.svg';
import { ReactComponent as FileText } from 'Icons/file-text.svg';
import { ReactComponent as ModelFund } from 'Icons/model-fund.svg';
import { ReactComponent as Settings } from 'Icons/settings.svg';
import { ReactComponent as Stack } from 'Icons/stack.svg';
import { ReactComponent as ExclamationCircle } from 'Icons/exclamation-circle.svg';
import { ReactComponent as Close } from 'Icons/close.svg';
import { ReactComponent as ChevronDown } from 'Icons/chevron-down.svg';
import { ReactComponent as Help } from 'Icons/help.svg';
import { ReactComponent as Bell } from 'Icons/bell.svg';
import { ReactComponent as ArrowLeft } from 'Icons/arrow-left.svg';
import { ReactComponent as FlagUs } from 'Icons/flag-usa.svg';
import { ReactComponent as FlagFr } from 'Icons/flag-fr.svg';
import { ReactComponent as FlagEs } from 'Icons/flag-es.svg';
import { ReactComponent as Plus } from 'Icons/plus.svg';
import { ReactComponent as PlusEllipsis } from 'Icons/plus-ellipsis.svg';
import { ReactComponent as MinusCircle } from 'Icons/minus-circle.svg';
import { ReactComponent as More } from 'Icons/more.svg';
import { ReactComponent as Search } from 'Icons/search.svg';
import { ReactComponent as Filter } from 'Icons/filter.svg';
import { ReactComponent as Download } from 'Icons/download.svg';
import { ReactComponent as Move } from 'Icons/move.svg';
import { ReactComponent as Check } from 'Icons/check.svg';
import { ReactComponent as CheckCircle } from 'Icons/check-circle.svg';
import { ReactComponent as Delete } from 'Icons/delete.svg';
import { ReactComponent as Edit } from 'Icons/edit.svg';
import { ReactComponent as Password } from 'Icons/password.svg';
import { ReactComponent as Users } from 'Icons/users.svg';
import { ReactComponent as Restore } from 'Icons/restore.svg';
import { ReactComponent as Import } from 'Icons/import.svg';
import { ReactComponent as Copy } from 'Icons/copy.svg';
import { ReactComponent as Unlock } from 'Icons/unlock.svg';
import { ReactComponent as Lock } from 'Icons/lock.svg';
import { ReactComponent as InfoOutlined } from 'Icons/info-outlined.svg';
import { ReactComponent as Hierarchy } from 'Icons/hierarchy.svg';
import { ReactComponent as Information } from 'Icons/information.svg';
import { ReactComponent as Property } from 'Icons/property.svg';
import { ReactComponent as Like } from 'Icons/like.svg';
import { ReactComponent as Dislike } from 'Icons/dislike.svg';
import { ReactComponent as Neutral } from 'Icons/neutral.svg';
import { ReactComponent as TrendUp } from 'Icons/trend-up.svg';
import { ReactComponent as TrendDown } from 'Icons/trend-down.svg';
import { ReactComponent as Envelope } from 'Icons/envelope.svg';
import { ReactComponent as Click } from 'Icons/click.svg';
import { ReactComponent as NewWindow } from 'Icons/new-window.svg';
import { ReactComponent as Reward } from 'Icons/reward.svg';
import { ReactComponent as Sandglass } from 'Icons/sandglass.svg';
import { ReactComponent as Play } from 'Icons/play.svg';
import { ReactComponent as DownloadCircle } from 'Icons/download-circle.svg';
import { ReactComponent as Report } from 'Icons/report.svg';
import { ReactComponent as Calendar } from 'Icons/calendar.svg';
import { ReactComponent as Profile } from 'Icons/profile.svg';
import { ReactComponent as Success } from 'Icons/success.svg';
import { ReactComponent as Discount } from 'Icons/discount.svg';
import { ReactComponent as Time } from 'Icons/time.svg';
import { ReactComponent as EyeCrossed } from 'Icons/eye-crossed.svg';
import { ReactComponent as EyeOpened } from 'Icons/eye-opened.svg';
import { ReactComponent as MappingSetting } from 'Icons/mapping-settings.svg';
import { ReactComponent as NotStarted } from 'Icons/not-started.svg';
import { ReactComponent as  InComplete} from 'Icons/incomplete.svg';
import { ReactComponent as NeedsReview } from 'Icons/needs-review.svg';
import { ReactComponent as CreateMapping } from 'Icons/create-mapping.svg';
import { ReactComponent as UnMapping } from 'Icons/unmapping.svg';
import { ReactComponent as Tenant } from 'Icons/tenant.svg';
import { ReactComponent as Excel } from 'Icons/excel.svg';
import { ReactComponent as UploadFile } from 'Icons/upload-file.svg';
import { ReactComponent as UploadPlaceholder } from 'Icons/upload-placeholder.svg';
import { ReactComponent as AddNewMapping } from 'Icons/add-new-mapping.svg';
import { ReactComponent as CreateNewMapping } from 'Icons/create-new-mapping.svg';
import { ReactComponent as ModalConfirmation } from 'Icons/modal-confirmation.svg';
import { ReactComponent as MappingEdit } from 'Icons/mapping-edit.svg';
import { ReactComponent as MappingIgnore } from 'Icons/mapping-ignore.svg';
import { ReactComponent as MappingTrash } from 'Icons/mapping-trash.svg';
import { ReactComponent as Matches } from 'Icons/matches.svg';

import { ReactComponent as AlertSuccess } from 'Icons/alert-success.svg';
import { ReactComponent as MappingSummary } from 'Icons/mapping-summary.svg';
import { ReactComponent as TenantFile } from 'Icons/tenant-file.svg';
import { ReactComponent as Confirmation } from 'Icons/confirmation.svg';
import { ReactComponent as RemovedMapping } from 'Icons/removed-mapping.svg';
import { ReactComponent as NewMapping } from 'Icons/new-mapping.svg';
import { ReactComponent as NoChanges } from 'Icons/no-changes.svg';
import { ReactComponent as SelectSuffix } from 'Icons/select-suffix.svg';
import { ReactComponent as TenantSuffix } from 'Icons/tenant-suffix.svg';
import { ReactComponent as MappingComplete } from 'Icons/mapping-complete.svg';
import { ReactComponent as Completed } from 'Icons/completed.svg';

import { ReactComponent as ChevronUp } from 'Icons/chevron-up.svg';
import { ReactComponent as ChevronUpDown } from 'Icons/chevrons-up-down.svg';
import { ReactComponent as Compliant } from 'Icons/compliant.svg';
import { ReactComponent as NonCompliant } from 'Icons/non-compliant.svg';
import { ReactComponent as SAQTooltip } from 'Icons/saq-tooltip.svg';
import { ReactComponent as AntSelectSuffix } from 'Icons/ant-select-suffix.svg';
import { ReactComponent as SAQExternalLink } from 'Icons/saq-external-link.svg';
import { ReactComponent as SAQSearch } from 'Icons/saq-search.svg';
import { ReactComponent as NonCompliantCard } from 'Icons/non-compliant-card.svg';
import { ReactComponent as SAQNumber } from 'Icons/saq-number.svg';
import { ReactComponent as SAQPercent } from 'Icons/saq-percent.svg';
import { ReactComponent as TrendingArrow } from 'Icons/trending-arrow.svg';
import { ReactComponent as UnmapExclamatory } from 'Icons/unmap-exclamatory.svg';
import { ReactComponent as ConnectionArrow } from 'Icons/connection-arrow.svg';
import { ReactComponent as RestoreReverse } from 'Icons/restore-reverse.svg';
import { ReactComponent as Remove } from 'Icons/remove.svg';
import { ReactComponent as NewLogo } from 'Icons/newLogo.svg';
import { ReactComponent as VenzaLanding } from 'Icons/venzaLanding.svg';


const Icons = {
	snippets: SnippetsOutlined,
	eye: Eye,
	filter: Filter,
	fileText: FileText,
	modelFund: ModelFund,
	settings: Settings,
	stack: Stack,
	search: Search,
	close: Close,
	question: QuestionCircleOutlined,
	global: GlobalOutlined,
	exclamationCircle: ExclamationCircle,
	chevronDown: ChevronDown,
	bell: Bell,
	help: Help,
	arrowLeft: ArrowLeft,
	flagUs: FlagUs,
	flagFr: FlagFr,
	flagEs: FlagEs,
	plus: Plus,
	plusEllipsis: PlusEllipsis,
	minusCircle: MinusCircle,
	more: More,
	download: Download,
	move: Move,
	check: Check,
	checkCircle: CheckCircle,
	delete: Delete,
	edit: Edit,
	password: Password,
	users: Users,
	restore: Restore,
	import: Import,
	copy: Copy,
	unlock: Unlock,
	lock: Lock,
	infoOutlined: InfoOutlined,
	hierarchy: Hierarchy,
	information: Information,
	property: Property,
	like: Like,
	dislike: Dislike,
	neutral: Neutral,
	loading: LoadingOutlined,
	trendUp: TrendUp,
	trendDown: TrendDown,
	envelope: Envelope,
	click: Click,
	newWindow: NewWindow,
	reward: Reward,
	sandglass: Sandglass,
	play: Play,
	downloadCircle: DownloadCircle,
	report: Report,
	calendar: Calendar,
	profile: Profile,
	success: Success,
	discount: Discount,
	time: Time,
	eyeCrossed: EyeCrossed,
	eyeOpened: EyeOpened,
	mappingSetting: MappingSetting,
	notStarted: NotStarted,
	inComplete: InComplete,
	inactive: InComplete,
	completed: Completed,
	needsReview: NeedsReview,
	createMapping: CreateMapping,
	unMapping: UnMapping,
	tenantSuffix: TenantSuffix,

	mappingComplete: MappingComplete,
	tenant: Tenant,
	excel: Excel,
	uploadFile: UploadFile,
	uploadPlaceholder: UploadPlaceholder,

	addNewMapping: AddNewMapping,
	createNewMapping: CreateNewMapping,
	modalConfirmation: ModalConfirmation,
	mappingEdit: MappingEdit,
	mappingTrash: MappingTrash,
	mappingIgnore: MappingIgnore,
	matches: Matches,

	alertSuccess: AlertSuccess,
	mappingSummary: MappingSummary,
	tenantFile: TenantFile,
	confirmation: Confirmation,
	removedMapping: RemovedMapping,
	newMapping: NewMapping,
	noChanges: NoChanges,
	selectSuffix: SelectSuffix,
	chevronUp: ChevronUp,
	chevronUpDown: ChevronUpDown,
	compliant: Compliant,
	nonCompliant: NonCompliant,
	saqTooltip: SAQTooltip,
	antSelectSuffix: AntSelectSuffix,
	saqExternalLink: SAQExternalLink,
	saqSearch: SAQSearch,
	saqPercent: SAQPercent,
	saqNumber: SAQNumber,
	nonCompliantCard: NonCompliantCard,
	trendingArrow: TrendingArrow,
	unmapExclamatory: UnmapExclamatory,
	connectionArrow: ConnectionArrow,
	restoreReverse: RestoreReverse,
	remove: Remove,
	venzaLanding: VenzaLanding,
	newLogo: NewLogo
};

export default Icons;
